import { get } from 'lodash/fp';
import styled, { css } from 'styled-components';
import Checkbox from '../../FormElements/Checkbox';

export const ValidationError = styled.div`
color: red;
`;

export const StyledItemSelector = styled.label`
background-color: white;
display: flex;
flex-direction: row;
align-items: center;
padding: 10px;
border-bottom: 1px solid #ccc;
min-height: 75px;
${({ disabled }) => !disabled && css`cursor: pointer`}

${({ isSelected, theme }) => isSelected && css`
  background-color: ${get('color.selected.background', theme)};
`};

label {
  flex: 3;
  display: flex;
  font-size: 16px;
  max-width: 28%;
}

.details {
  align-content: center;
  justify-content: center;
  font-size: 14px;
  display: flex;
  flex: 5.5;
  flex-direction: column;
  .label {
    font-weight: bold;
  }
}
`;

export const ItemSelectorCheckbox = styled(Checkbox)`
span {
  ${({ disabled }) => disabled && css`
    background-color: lightgrey;
  `}
}`;

export const ItemSelectorIcon = styled.div`
display: flex;
flex-direction: row;
flex: 1.5;
align: center;
`;


export const ValidationErrors = styled.div`
display: flex;
flex-direction: column;
flex: 5.5;
font-size: 14px;
`;
